import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ChannelDirectoryEditModal from './ChannelDirectoryEditModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.channelDirectoryEditModal.status,
  id: state.modal.channelDirectoryEditModal.id,
  name: state.modal.channelDirectoryEditModal.name
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_STORAGE_DIRECTORY_EDIT, { status: false, id: null, name: null }),
  resetTable: () => actions.channel.updateTable({
    checkedList: [],
    indeterminate: false,
    checkAll: false
  }),
  editDirectory: actions.channel.editDirectory
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChannelDirectoryEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelDirectoryEditModal/index.js